export const GET_LOCAL_LANDING_ACTION: string = 'getLocalLanding' 
export const GET_EXTERNAL_LANDING_ACTION: string = 'getExternalLanding' 
export const UPDATE_EXTERNAL_LANDING_ACTION: string = 'updateExternalLanding' 
export const GET_FB_GOODS_ACTION: string = 'getFBGoods' 
export const GET_WEBSITE_TAGS: string = 'getWebsiteTags' 
